import { MobileNavbar } from './mobile';
import { PCNavbar } from './PC';
import { LinkHref } from './config';

interface IProps {
  initType?: 'transparent' | 'white';
  mobile?: 'transparent' | 'white';
  pc?: 'transparent' | 'white';
  mobileMode?: 'default' | 'embedded';
  mobileClassName?: string;
  mobileRootClassName?: string;
  pcRootClassName?: string;
  hideEmbeddedTitle?: boolean;
  mobileMenuIcon?: React.ReactNode;
  mobileMenuButtonClassName?: string;
  cssBox?: string;
  boxStyle?: React.CSSProperties;
  isDetail?: boolean;
  title?: string;
  isAdmin?: boolean;
  // 自定义退出行为；不传则默认跳 /login
  onLogout?: () => void;
}
export const Navbar = ({
  initType = 'white',
  mobile,
  pc,
  mobileMode = 'default',
  mobileClassName,
  mobileRootClassName,
  pcRootClassName,
  hideEmbeddedTitle,
  mobileMenuIcon,
  mobileMenuButtonClassName,
  title,
  onLogout,
  ...otherProps
}: IProps) => {
  return (
    <>
      <PCNavbar
        type={pc ?? initType}
        title={title}
        onLogout={onLogout}
        rootClassName={pcRootClassName}
        {...otherProps}
      />
      <MobileNavbar
        initType={mobile ?? initType}
        mobileMode={mobileMode}
        className={mobileClassName}
        rootClassName={mobileRootClassName}
        hideEmbeddedTitle={hideEmbeddedTitle}
        mobileMenuIcon={mobileMenuIcon}
        mobileMenuButtonClassName={mobileMenuButtonClassName}
        title={title}
        onLogout={onLogout}
      />
    </>
  );
};

export { LinkHref };
export { PCNavbar, MobileNavbar };
export {
  isConferenceChatLogoutInProgress,
  setConferenceChatLogoutInProgress,
} from './conferenceChat';
